import React from 'react'
import { NavLink } from 'react-router-dom'
import react, { useState, useEffect } from 'react';
import Modal from 'react-modal';

Modal.setAppElement('#root'); // set the app element for accessibility

const TenderNoticePopup = ({ isOpen, onClose }) => {
    const tenderDocUrl = "https://www.mangaonseniorcollege.com/Tender Chem equip.pdf";
const tenderDocUrll = "https://www.mangaonseniorcollege.com/Tender Renovation.pdf";
    
    
    return isOpen && (
      <div style={{
        position: 'fixed',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0,0,0,0.5)',
        zIndex: 1000,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        <div style={{
          backgroundColor: 'white',
          padding: '2rem',
          borderRadius: '8px',
          maxWidth: '600px',
          textAlign: 'center'
        }}>
          <h2 style={{ color: '#1a237e', marginBottom: '1rem' }}>College Tender Notice</h2>
          <p style={{ marginBottom: '1.5rem' }}>
            Important tender notification has been published. Please check the document for details and submission guidelines.
          </p>
          
          <a
            href={tenderDocUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              backgroundColor: '#1a237e',
              color: 'white',
              padding: '0.8rem 1.5rem',
              borderRadius: '4px',
              textDecoration: 'none',
              display: 'inline-block',
              marginBottom: '1rem'
            }}
          >
            View Tender Chem Equipment Document
          </a>

                <a
            href={tenderDocUrll}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              backgroundColor: '#1a237e',
              color: 'white',
              padding: '0.8rem 1.5rem',
              borderRadius: '4px',
              textDecoration: 'none',
              display: 'inline-block',
              marginBottom: '1rem'
            }}
          >
            View Tender Renovation Document
          </a>
  
          <button
            onClick={onClose}
            style={{
              display: 'block',
              margin: '0 auto',
              padding: '0.5rem 1rem',
              backgroundColor: '#e0e0e0',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Close
          </button>
        </div>
      </div>
    );
  };
  
  
const Home = () => {
    const [isOpen, setIsOpen] = useState(false);
    useEffect(() => {
        setIsOpen(true); // set the isOpen state to true when the component mounts
      }, [])

    return (
        <>
           
          <marquee>
    <h3>
        <a href="https://drive.google.com/file/d/1QVCpEf2zrKGDF4o1ykorfrQvAyqrBv5f/view?usp=sharing" target="_blank">Click here to View Tender</a>
    </h3>
</marquee>

            {/* slider */} 
                    <div  id="myCarousel" className="carousel slide" data-ride="carousel">

                        <ol class="carousel-indicators">
                            <li data-target="#myCarousel" data-slide-to="0" className="active"></li>
                            <li data-target="#myCarousel" data-slide-to="1"></li>
                            <li data-target="#myCarousel" data-slide-to="2"></li>
                            <li data-target="#myCarousel" data-slide-to="3"></li>
                        </ol>


                        <div class="carousel-inner">
                            
<div className="item active ">
                                <img src="images/clg-front-view/12.jpeg" alt="Los Angeles" style={{width:"100%",height:"100%",filter:" brightness(50%)"}} />
                            </div>
                            <div className="item">
                                <img src="images/clg-front-view/peer team/DSC_3321.JPG" alt="New york"style={{width:"100%",height:"100%",filter:" brightness(50%)"}}/>
                            </div>
                           
                            <div className="item">
                                <img src="images/clg-front-view/4.jpg" alt="New york"style={{width:"100%",height:"100%",filter:" brightness(50%)"}}/>
                            </div>
 
 <div className="item">
                                <img src="images/clg-front-view/3.jpg" alt="New york"style={{width:"100%",height:"100%",filter:" brightness(50%)"}}/>
                            </div>  

                           
                           
                        </div>

                        {/* <a class="left carousel-control" style={{zIndex:"2"}} href="#myCarousel" data-slide="prev">
                            <span className="glyphicon glyphicon-chevron-left"></span>
                            <span className="sr-only">Previous</span>
                        </a> */}
                        <a class="right carousel-control" style={{zIndex:"2"}} href="#myCarousel" data-slide="next">
                            <span className="glyphicon glyphicon-chevron-right"></span>
                            <span className="sr-only">Next</span>
                        </a>
                    </div>
           
            <div className="main" >
                  
                {/* <h1  >Welcome to our college</h1> */}
                <p style={{marginTop:"20%"}} >
                <h1  >Welcome to our college</h1>
                <span  style={{fontSize:"5rem",float:"left",textShadow:"none", margin: "1.2rem .2em 0.3rem 0",color:"orange"}}>M</span>angaon Shikshan Prasarak Mandal, Mangaon and its President Adv. Rajivji Sable laid the foundation stone of higher education in Mangaon on 1993. It was that time known as Arts’ Senior College. Later It was named as D.G.Tatkare College on 10th January 2010.
                </p>
                <div className="social-icons">
                    <a href="tel:02140-263928" style={{ color: "sky" }} class="fa fa-phone"></a>
                    <a href="/" style={{ color: "blue" }} class="fa fa-facebook-square"></a>
                    <a href="mailto:mspmmangaonseniorcollege@gmail.com" style={{ color: "red" }} class="fa fa-envelope"></a>
                </div>

                <div style={{ display: "flex", color: "white" }}>
                    <a style={{ color: "white", border: "1px solid white" }} href="#contact" className="mybtn text-center">Contact Us</a>
                </div>

            </div>
            {/* //slider */}
            <br />
            {/* About */}
            <div class="container-fluid" data-aos="fade-right">
                <h3 class="title" >
                    President Message
                </h3>
                <div class="header">
                    <p><i class="fa fa-graduation-cap" aria-hidden="true"></i></p>
                </div>
                <div class="col-md-3 w3l_about_bottom_left"  >
                    <div class="team-grid" style={{ border: "1px solid black" }}>
                        <div class="  about-poleft t1">
                            <div class="about_img"><img src="images/President.jpg" width="100%" height="100%" alt="" />
                                <h5 style={{ lineHeight: "20px" }}> <span style={{ fontSize: "20px", marginTop: "10px" }}>Hon. Adv. Rajiv Ashok Sable
</span><span style={{ fontSize: "15px" }}>President</span></h5>
                                
                            </div>
                        </div>
                        <div class="clearfix"></div>
                    </div>
                </div>
                <div class="col-md-9 " style={{ padding: "auto auto auto 20px", display: "flex", height: "100%", alignItems: "center", justifyContent: "center" }}>
                    <p >
                        <span  style={{fontSize:"5rem",float:"left", margin: "1.2rem .2em 0.3rem 0",color:"orange"}}>M</span>angaon Shikshan Prasarak Mandal was founded by some education lovers of Mangaon. Starting from a single class, today it has become a huge institution. Growing and progressing day by day, today it holds KG to PG section. There are total 7 units in this institution, namely  Sudhakar Narayan Shipurkar Pre-Primary English Medium School, Ganesh Yashwant Waghre English Medium School, Mangaon Junior  College, Ashok Dada Sable Vidyalay , Mangaon Junior College, D.G. Tatkare Junior College, D.G.Tatkare Mahaviyalay and Ashok Dada Sable Law College. The motto of the organization is 'Sheelm Param Bhushanam'. We believe in humanity, our organization focuses on building not only students career but also developing humanity and  social awareness in them. This college was established in 1993 by Maharishi Ex MLA late Ashok Dada Sable, The well wisher of Mangaon.  College was first started with the Arts Faculty, but today this work of education donation is being done in total 12 branches of graduation and post-graduation, which is a matter of pride for us. Respected office bearers of Mangaon Shikshan Prasarak Mandal had given me the responsibility of the post of President in 1993.  Since then  I have been handling this institution skillfully for 30 consecutive years.  I am thankful to the well-wishers of this institution who gave me a chance to serve.  Through this, the holy work of providing education to about 1200 poor students of rural areas is being done. The principal, teaching and non-teaching staff of the college, have taken continuous care and efforts in the all over development of the students, which is a matter of happiness. I wish all the well-wishers, teachers and non-teaching staff and students of this college have a very bright future.</p>
                </div>
                <div class="clearfix"> </div>
            </div>
            <div class="container-fluid" data-aos="fade-right">
                <h3 class="title" >
                    Principal Message
                </h3>
                <div class="header">
                    <p><i class="fa fa-graduation-cap" aria-hidden="true"></i></p>
                </div>
                <div class="col-md-3 w3l_about_bottom_left"  >
                    <div class="team-grid" style={{ border: "1px solid black" }}>
                        <div class="  about-poleft t1">
                            <div class="about_img"><img src="images/t-staff/Pandey.jpg" width="100%" alt="" />
                                <h5 style={{ lineHeight: "20px" }}> <span style={{ fontSize: "20px", marginTop: "10px" }}>Dr.Jayshankar R.Pandey
</span><span style={{ fontSize: "15px" }}>Principal</span></h5>
                                <div class="about_opa">
                                    <p >Principal</p> 
                                    Principal :+91 9822235709/+91 8421780049
                                        Principal (Email) - jrpandey79@gmail.com 
                                </div>
                            </div>
                        </div>
                        <div class="clearfix"></div>
                    </div>
                </div>
                <div class="col-md-9 " style={{ padding: "auto auto auto 20px", display: "flex", height: "100%", alignItems: "center", justifyContent: "center" }}>
                    <p >
                        <span  style={{fontSize:"5rem",float:"left", margin: "1.2rem .2em 0.3rem 0",color:"orange"}}>H</span>uman being is born, but to being a human is created. This creation is made by education. Higher education is apex level of education. It is what which makes a man higher. Mangaon Shikshan Prasarak Mandal, Mangaon and its president Adv. Rajivji sable laid the foundation stone of higher education in Mangaon 1993. It was at that time known as Arts senior college. Later it was named as D.G. Tatkare Mahavidyalay.on 10th Jan 2010. Recently the college is serving under graduation degree in Arts, Science, Commerce, Information Technology (IT), Management studies and BAF (Bachelor of account and Finance). Along with UG college is catering PG Course in Organic Chemistry, Information Technology, Marathi, Hindi, History, and Commerce. In short being in rural area college is promoting 6 UG and 6 PG courses under affiliation of  Mumbai University. Best efforts are put by college to provide value based, quality based and activity-oriented education. More than 30 research papers are published in UGC care listed and Peer  reviewed journals. College is blessed with qualified teaching and hardworking non-teaching staff. Students are provided with best of guidance in terms of notes, extra lectures, career counseling, guest lectures etc. Extension activities like national service scheme and life-long learning have enriched the value-based education. College have gained satisfactory achievements in field of extension activities in terms of awards and designations. To enhance the activity-based knowledge of students, college conducts annual sports (meet Anand Tarang), annual social culture events including (Dance and Drama) various scientific activities participation in Avishkar best from waste activities etc.  To nurture the students and create competent role model for the society, college organizes competitions (Essay, Elocution, debate, story writing) seminars, presentation viva – voce etc. conduction of such events as a regular part of higher education makes the student resourceful for facing the challenge of ever-changing society. Malhar and Anand Tarang social fest induce versatility in the personality of the students. College takes initiative to appreciate students by honoring trophies medals and mementos for encouraging their talents in field of academic and co-curricular. College taken initiative in conduction of national and international conferences, seminar various workshop and innovative research activities such activities enhance intellectually stimulating environment in the campus.</p>
                </div>
                <div class="clearfix"> </div>
            </div>
            <br />
            <hr />
            <div class="container" data-aos="fade-up-right" >
                <h3 class="title">
                    -About Us-
                </h3>
                <div class="header">
                    <p><i class="fa fa-graduation-cap" aria-hidden="true"></i></p>
                </div>
                <div class="col-md-6 w3l_about_bottom_left"  >
                    <div class="video-grid-single-page-agileits">
                        <div data-video="kmKlYMBiwXk" id="video"> <img
 
                            src="images/clg-front-view/4.jpg" alt="" className="img-responsive"
 
                            // src="images/clg-front-view/dgt2.jpg" alt="" className="img-responsive" 
                            style={{ width: "100%", height: "100%" }} /> 
                            <h3>MSPM President Adv. Rajiv Sable discussed with Maharashtra State Deputy Chief Minister Hon. Shri Eknath Shinde Saheb</h3>
                            </div>
                    </div>
                </div>
                <div class="col-md-5 " style={{ padding: "40px 0px 0px 20px ,marginTop:10rem " }}>
                    <h3 class="text-warning">Welcome to Our College</h3>
                    <p> <span  style={{fontSize:"5rem",float:"left", margin: "1.2rem .2em 0.3rem 0",color:"orange"}}>M</span>angaon Shikshan Prasarak Mandal, Mangaon and its President Adv. Rajivji Sable laid a
                        foundation stone of higher education in Mangaon on 1993. It was that time known as Arts’
                        Senior College. Later It is named as D.G.Tatkare College on 10th January 2010.</p>
                    <div class="container-fluid" style={{ display: "flex", marginTop: "50px" }}>
                        <a href="/" class="mybtn " ><span><NavLink to="/aboutsansta">Read More </NavLink></span></a>  &nbsp; &nbsp; &nbsp; &nbsp;
                        <a href="#contact" className="front-btn mybtn scroll" ><span >Contact Us</span></a>
                    </div>
                </div>
                <div class="clearfix"> </div>
            </div>
            <div class="services" id="services">
                <div class="container">
                    <div class="modal about-modal agileits fade" id="facilitymodal" tabIndex="-1" role="dialog">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">close</button>
                                </div>
                                <div class="modal-body">
                                    <img src="images/dgtc.PNG"></img>
                                    
                                    <p>
                                        Comming soon...|Comming soon...|Comming soon...|Comming
                                        soon...|Comming
                                        soon...|Comming soon...|Comming soon...|Comming
                                        soon...|Comming
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br /><br />
            {/* //About */}
            {/* Services */}
            <hr />
            <div class="container-fluid" >
                <div class="row">
                    <h3 class="title">  Our Facilities </h3>
                </div>
                <br></br>
                <div class="Facility-row row" data-aos="zoom-in" >
                    <div class="facility col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12"    >
                        <div className="sub-facility">
                            <h2 align="center">Library</h2>
                            <div class="header">
                                <p ><i class="fa fa-graduation-cap" aria-hidden="true"></i></p>
                            </div>
                            <p className="facility-p"> It is enriched with books over 10,000; periodical over 17; daily news papers over 13. Library is with daily book issuing counter and reading room. In near future, the library will be equipped with e-issuing counter computers.
                            </p>
                            <div style={{ display: "flex", justifyContent: "center", margin: "20px 0" }}>
                                <NavLink to="library" style={{color:"white",borderColor:"white"}}  className="mybtn" id="mybtn" >Learn More</NavLink>
                            </div>
                        </div>
                    </div>
                    <div class="facility col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12"   >
                        <div className="sub-facility">
                            <h2 align="center">Reading Room</h2>
                            <div class="header">
                                <p ><i class="fa fa-graduation-cap" aria-hidden="true"></i></p>
                            </div>
                            <p className="facility-p">
                                Separate reading room is there at Terace. It is of about 150 student's capacity. Cool breeze of nature with natural light enhances environment for study. Reading room provides place to learn for students. It is added advantage to students for working hard to gain more in examinations.
                            </p>
                            <div style={{ display: "flex", justifyContent: "center", margin: "20px 0" }}>
                                <button className="mybtn" style={{color:"white",borderColor:"white"}}  id="mybtn">Learn More</button>
                            </div>
                        </div>
                    </div>

                    <div class="facility col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12"   >
                        <div className="sub-facility">
                            <h2 align="center">Student Corner</h2>
                            <div class="header">
                                <p ><i class="fa fa-graduation-cap" aria-hidden="true"></i></p>
                            </div>
                            <p className="facility-p" >It is natural venue for students. Inside the college campus students can enjoy natural joy. It is 'SPACE' for students. The place is for dine, chit-chat, write the applications, to wait for friends, share the feelings, help to each other to build bond of friendship. It has lawn, natural roof, Drinking water facilities with water purifier.
                            </p>
                            <div style={{ display: "flex", justifyContent: "center", margin: "20px 0" }}>
                                <button className="mybtn" style={{color:"white",borderColor:"white"}}  id="mybtn">Learn More</button>
                            </div>
                        </div>
                    </div>

                </div>
                <br></br><br></br>
                <div class="Facility-row row" data-aos="zoom-in" >
                    <div class="facility col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12"   >
                        <div className="sub-facility">
                            <h2 align="center">Gymkhana</h2>
                            <div class="header">
                                <p ><i class="fa fa-graduation-cap" aria-hidden="true"></i></p>
                            </div>
                            <p className="facility-p">Gymnasium - Carrom board, Chess boards, Table tennis, Volley ball, badminton, physical exercise equipment are well maintained. Bat, balls, stumps, net and mat are for student to play cricket. On play ground, special grounds are maintained for kho-kho, kabbadi, volley ball, cricket pitch facilities are available.
                            </p>
                            <div style={{ display: "flex", justifyContent: "center", margin: "20px 0" }}>
                                <button className="mybtn" id="mybtn" style={{color:"white",borderColor:"white"}} >Learn More</button>
                            </div>
                        </div>
                    </div>
                    <div class="facility col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12"  >
                        <div className="sub-facility">
                            <h2 align="center">Reading room</h2>
                            <div class="header">
                                <p ><i class="fa fa-graduation-cap" aria-hidden="true"></i></p>
                            </div>
                            <p className="facility-p">
                                Separate reading room is there at Terace. It is of about 150 student's capacity. Cool breeze of nature with natural light enhances environment for study. Reading room provides place to learn for students. It is added advantage to students for working hard to gain more in examinations.
                            </p>
                            <div style={{ display: "flex", justifyContent: "center", margin: "20px 0" }}>
                                <button className="mybtn" style={{color:"white",borderColor:"white"}}  id="mybtn">Learn More</button>
                            </div>
                        </div>
                    </div>
                    <div class="facility col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12"  >
                        <div className="sub-facility">
                            <h2 align="center">Multipurpose Hall</h2>
                            <div class="header">
                                <p ><i class="fa fa-graduation-cap" aria-hidden="true"></i></p>
                            </div>
                            <p className="facility-p">It has over 250 sitting capacity Hall. It is airy with ample windows and fans. The decoraive backdrop, dice, podium are added advantage. It has LCD projector as added advantage. It has LCD projector as advanced teaching aids for students. Built in sound and light system, POP designed ceilling make elligant look of multipurpose hall.
                            </p>
                            <div style={{ display: "flex", justifyContent: "center", margin: "20px 0" }}>
                                <button className="mybtn" style={{color:"white",borderColor:"white"}}  id="mybtn">Learn More</button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            {/* //services  */}
            {/* Gallery  */}
            <hr />

            <section className="portfolio-w3ls" id="gallery" data-aos="zoom-in">
                <h3 className="title">
                    Our Gallery
                </h3>
                <div className="header">
                    <p><i className="fa fa-graduation-cap" aria-hidden="true"></i></p>
                </div>
                <div className="col-md-3 col-xs-3 gallery-grid gallery1" style={{ height: "250px", width: "250px", }} >
                    <a href="images/tour/Readingroom.jpg" className="swipebox"><img src="images/tour/Readingroom.jpg"
                        className="img-responsive"  alt="/"></img>
                        <div className="textbox">
                            <h4>DGTC</h4>
                            <p><i className="fa fa-picture-o" aria-hidden="true"></i></p>
                        </div>
                    </a>
                </div>
                <div className="col-md-3 col-xs-3 gallery-grid gallery1" style={{ height: "250px", width: "250px", }} >
                    <a href="images/tour/sports.jpg" className="swipebox"><img src="images/tour/sports.jpg"
                        className="img-responsive" alt="/"></img>
                        <div className="textbox">
                            <h4>DGTC</h4>
                            <p><i className="fa fa-picture-o" aria-hidden="true"></i></p>
                        </div>
                    </a>
                </div>
                <div className="col-md-3 col-xs-3 gallery-grid gallery1" style={{ height: "250px", width: "250px", }}>
                    <a href="images/tour/garden.jpg" className="swipebox"><img src="images/tour/garden.jpg"
                        className="img-responsive" alt="/"></img>
                        <div className="textbox">
                            <h4>DGTC</h4>
                            <p><i className="fa fa-picture-o" aria-hidden="true"></i></p>
                        </div>
                    </a>
                </div>
                <div className="col-md-3 col-xs-3 gallery-grid gallery1" style={{ height: "250px", width: "250px", }}>
                    <a href="images/tour/ground.jpg" className="swipebox"><img src="images/tour/ground.jpg"
                        className="img-responsive" alt="/"></img>
                        <div className="textbox">
                            <h4>DGTC</h4>
                            <p><i className="fa fa-picture-o" aria-hidden="true"></i></p>
                        </div>
                    </a>
                </div>
                <div className="col-md-3 col-xs-3 gallery-grid gallery1" style={{ height: "250px", width: "250px", }}>
                    <a href="images/tour/multipurpose.jpg" className="swipebox"><img src="images/tour/Greendgt.jpg"
                        className="img-responsive" alt="/"></img>
                        <div className="textbox">
                            <h4>DGTC</h4>
                            <p><i className="fa fa-picture-o" aria-hidden="true"></i></p>
                        </div>
                    </a>
                </div>
                <div className="col-md-3 col-xs-3 gallery-grid gallery1" style={{ height: "250px", width: "250px", }}>
                    <a href="images/tour/scorner1.jpg" className="swipebox"><img src="images/tour/scorner1.jpg"
                        className="img-responsive" alt="/"></img>
                        <div className="textbox">
                            <h4>DGTC</h4>
                            <p><i className="fa fa-picture-o" aria-hidden="true"></i></p>
                        </div>
                    </a>
                </div>
                <div className="col-md-3 col-xs-3 gallery-grid gallery1" style={{ height: "250px", width: "250px", }}>
                    <a href="images/tour/physics.jpg" className="swipebox"><img src="images/tour/physics.jpg"
                        className="img-responsive" alt="/"></img>
                        <div className="textbox">
                            <h4>DGTC</h4>
                            <p><i className="fa fa-picture-o" aria-hidden="true"></i></p>
                        </div>
                    </a>
                </div>
                <div id="contact" className="col-md-3 col-xs-3 gallery-grid gallery1" style={{ height: "250px", width: "250px", }}>
                    <a href="images/tour/scorner.jpg" className="swipebox"><img src="images/tour/scorner.jpg"></img>
                        <div className="textbox">
                            <h4>DGTC</h4>
                            <p><i className="fa fa-picture-o" aria-hidden="true"></i></p>
                        </div>
                    </a>
                </div>
                <div className="clearfix"> </div>
            </section>

            {/* //gallery */}
            <hr />
            {/* // contact  */}
            <br /> <br />

            <div className="Facility-row " data-aos="zoom-in" >
                <div className="facility col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12"  >
                    <div className="sub-facility" style={{background:"none" , display: "grid", placeItems: "center" }}>
                        <br/>
                        <h2 align="center"><i style={{ fontSize: "40px", color: "orange" }} className="fa fa-map-marker" aria-hidden="true"></i></h2>
                        <br />
                        <p style={{ display: "flex", flexDirection: "column", height: "150px", placeItems: "center" }}>
                            <h3>Address</h3>
                            <br />
                            <p>Near District Cort - Old Mangaon, </p>
                            <p>Raigad,Maharastra 402104,</p>
                        </p>
                    </div>
                </div>
                <div className="facility col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12" >
                    <div className="sub-facility" style={{ display: "grid", placeItems: "center",background:"none" }}>
                        <br />
                        <h2 align="center">	<i style={{ fontSize: "40px", color:"blueviolet" }} className="fa fa-mobile" aria-hidden="true"></i></h2>
                        <br />
                        <p style={{ display: "flex", flexDirection: "column", height: "150px", placeItems: "center" }}>
                            <h3>Phone</h3>
                            <br />
                            <p>College Office: +91 9822235709 <br /> <span>Principal :
                               +91 8421780049 </span></p>
                        </p>
                    </div>
                </div>
                <div className="facility col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12" >
                    <div className="sub-facility" style={{background:"none" , display: "grid", placeItems: "center" }}>
                        <br />
                        <h2 align="center"> <i style={{ fontSize: "40px", color: "red" }} className="fa fa-envelope-o" aria-hidden="true"></i></h2>
                        <br />
                        <p style={{ display: "flex", flexDirection: "column", height: "150px", placeItems: "center" }}>
                            <h3>Email</h3>
                            <br />
                            <p>
                            College : <a href="mailto:mspmmangaonseniorcollege@gmail.com"> mspmmangaonseniorcollege@gmail.com</a>
                                <br />
                                <span>Principal :<a href="mailto:jrpandey79@gmail.com "> jrpandey79@gmail.com </a></span>
                            </p>
                        </p>
                    </div>
                </div>

            </div>
            {/* popup for website */}
            {/* <Modal
  isOpen={isOpen}
  onRequestClose={() => setIsOpen(false)}
  contentLabel="Popup"
  style={{
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      zIndex: 10000, // Updated zIndex value for the overlay
    },
    content: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      maxWidth: '100%',
      maxHeight: '100%',
      WebkitOverflowScrolling: 'touch',
      padding: 0,
      border: 'none',
      background: 'transparent',
      zIndex: 10001, // Updated zIndex value for the content
    },
  }}
>
  <div style={{ position: 'absolute', top: '5%', right: '25%' }}>
    <button onClick={() => setIsOpen(false)}>X</button>
  </div>
  <img src="./images/banner.png" alt="Banner" style={{ width: '50%', height: '90%' }} />
</Modal> */}


            <br /> <br />  <br /> <br /><br /> <br />  <br /> <br /><br /> <br />  <br /> <br /><br /><br />
            <TenderNoticePopup isOpen={isOpen} onClose={() => setIsOpen(false)} />
        </>
    )
}

export default Home
